module.exports = __webpack_public_path__ + "img/fill_check.10435943.svg";